import React, { ChangeEventHandler } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { EditorContent, Editor as IEditor } from '@tiptap/react'
import { TextArea } from '@siftscience/focus-components/input'
import { TemplateDTO } from '../../dto/template'
import { EditorToolbar } from './editor-toolbar'

const useStyles = makeStyles(() => ({
  wrapper: {
    '& .tiptap.ProseMirror': {
      padding: '6px',
      height: '100%',

      '& p': {
        marginTop: '3px',
        marginBottom: '3px'
      },

      '& ul': {
        marginLeft: '40px',
        '& li': {
          listStyleType: 'disc'
        }
      }
    },
    height: '100%',
    '& table': {
      borderCollapse: 'collapse',
      margin: 0,
      overflow: 'hidden',
      tableLayout: 'fixed',
      width: '100%',

      '& .column-resize-handle': {
        backgroundColor: '#295ded',
        bottom: '-2px',
        pointerEvents: 'none',
        position: 'absolute',
        zIndex: 1,
        right: '-2px',
        top: 0,
        width: '4px'
      },
      '& td, & th': {
        border: '1px solid #E0E0E0',
        boxSizing: 'border-box',
        minWidth: '1em',
        padding: '6px 8px',
        position: 'relative',
        verticalAlign: 'top',

        '& > *': {
          marginBottom: 0
        }
      },
      '& th': {
        backgroundColor: '#F7F7F7',
        fontWeight: 'bold',
        textAlign: 'left'
      }
    }
  },
  editorWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '100%'
  },
  editorContent: {
    flex: 1
  },
  htmlEditor: {
    width: '100%',
    height: '100%',
    border: 'none',
    boxShadow: 'none'
  }
}))

interface EditorProps {
  editor: IEditor
  isRawHtmlView: boolean
  readonly: boolean
  template: TemplateDTO
  onHtmlEditorChange: ChangeEventHandler<HTMLTextAreaElement>
}

const Editor = ({
  editor,
  isRawHtmlView,
  readonly,
  template,
  onHtmlEditorChange
}: EditorProps) => {
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      {isRawHtmlView ? (
        <TextArea
          defaultValue={template?.content || ''}
          className={classes.htmlEditor}
          onChange={onHtmlEditorChange}
          readOnly={readonly}
        />
      ) : (
        <div className={classes.editorWrapper}>
          {!readonly && <EditorToolbar editor={editor} />}
          <EditorContent editor={editor} className={classes.editorContent} />
        </div>
      )}
    </div>
  )
}

export default Editor
